(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lb-product-extras"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-lbr-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.lbrOpen);
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
      return;
    }
    const closer = event.target.closest('[data-lbr-close]');
    if (closer) {
      closer.closest('dialog')?.close();
      return;
    }
    if (event.target instanceof HTMLDialogElement && event.target.classList.contains('lbr-dialog')) {
      event.target.close();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
